import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateLeadForm from '../../../modules/leads/components/CreateLeadForm';
import { useParams } from 'react-router-dom';

const CreateLead = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const title = id ? t('edit_lead') : t('create_lead');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/leads/create-lead' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateLeadForm />
    </div>
  );
};

export default CreateLead;
